"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var StreakIcon = function (_a) {
    var other = __rest(_a, []);
    return (react_1.default.createElement("svg", __assign({ style: { width: 20, height: 20 } }, other, { viewBox: "0 0 512 512" }),
        react_1.default.createElement("g", null,
            react_1.default.createElement("path", { d: "M338.5 199.5L116.5 328.5L207 462.5H317.5L393.5 322L338.5 199.5Z", fill: "#81D4FA" }),
            react_1.default.createElement("path", { d: "M304 1.52588e-05C194.887 62.8686 207.999 240 207.999 240C207.999 240 160 224 160 152C102.733 185.207 63.9998 249.033 63.9998 320C63.9998 426.039 149.961 512 256 512C362.039 512 448 426.039 448 320C447.999 164 304 132 304 1.52588e-05V1.52588e-05ZM272.865 445.843C234.283 455.462 195.207 431.984 185.585 393.4C175.966 354.818 199.445 315.739 238.028 306.12C331.177 282.896 342.851 230.514 342.851 230.514C342.851 230.514 389.301 416.811 272.865 445.843V445.843Z", fill: "#2196F3" }))));
};
exports.default = StreakIcon;
//# sourceMappingURL=StreakFreezeIcon.js.map